import classnames from 'classnames/bind'
import { GlobalGridPreset } from '~/@types/grid-preset'

import AccordionTitle, {
  AccordionTitleProps,
} from '~/components/UI/AccordionTitle'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface AccordionProps extends AccordionTitleProps {
  className?: string
}

function Accordion({ className, title, items }: AccordionProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })

  return (
    <div className={cx(css.Accordion, className, gridStyle)}>
      <AccordionTitle
        className={cx(css.accordionTitle)}
        titleClassName={cx(css.title)}
        title={title}
        items={items}
      />
    </div>
  )
}

Accordion.defaultProps = {}

export default Accordion
